import React from 'react'
import { toast } from 'react-toastify'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material'
import PropTypes from 'prop-types'

import OrderAPI from '../../../../../../api/orbitV1/OrderAPI'

/**
 * @param {Object} props
 * @param {string} props.orderNo
 * @param {boolean} props.isOpen
 * @param {() => void} props.onClose
 * @param {*} props.updateStateReqBody
 */
function RecommendedActionsDialogBox(props) {
  const updateStateAndClose = async () => {
    if (!props.deliveryType || props.deliveryType === 'manual') {
      try {
        const updatedOrderState = await OrderAPI.updateOrderState(
          props.orderNo,
          props.updateStateReqBody
        )
        if (updatedOrderState) {
          toast.success('Order successfully updated')
          props.onClose()
        }
      } catch (error) {
        toast.error('Failed to update order')
      }
    }

    if (props.deliveryType === 'grab') {
      props.setDeliveryLoading(true)
      props.onClose()
    }
  }

  return (
    <Dialog open={props.isOpen} onClose={props.onClose}>
      <DialogTitle>
        <strong>Confirm Order Update</strong>
      </DialogTitle>
      <DialogContent>Are you sure?</DialogContent>
      <DialogActions>
        <Button
          variant='filled'
          size='small'
          onClick={updateStateAndClose}
          data-cy='yesBtn'
        >
          Yes
        </Button>
        <Button
          variant='secondary'
          size='small'
          onClick={props.onClose}
          data-cy='noBtn'
        >
          No
        </Button>
      </DialogActions>
    </Dialog>
  )
}

RecommendedActionsDialogBox.propTypes = {
  isOpen: PropTypes.bool,
  orderNo: PropTypes.string,
  onClose: PropTypes.func,
  updateStateReqBody: PropTypes.object,
  deliveryType: PropTypes.string,
  setDeliveryLoading: PropTypes.func
}

export default RecommendedActionsDialogBox
